module.exports = __webpack_public_path__ + "img/21625029983_.pic.b2155366.jpg";